import { maintainScrollOnEndsUpdate } from "./maintainScrollOnEndsUpdate.js";
function getNewScrollValue(params) {
  const { updateScrollModeOnDataChange } = params;
  if (updateScrollModeOnDataChange === "none" || !updateScrollModeOnDataChange.addedAtTop && !updateScrollModeOnDataChange.removedFromTop && !updateScrollModeOnDataChange.addedAtBottom && !updateScrollModeOnDataChange.removedFromBottom) {
    return 0;
  }
  const tryToMaintainScroll = maintainScrollOnEndsUpdate({
    ...params,
    endsUpdateOptions: updateScrollModeOnDataChange
  });
  if (!tryToMaintainScroll.success) {
    return 0;
  }
  const { itemToMaintainVisible } = tryToMaintainScroll;
  const itemToMaintainVisibleUpdated = params.newItems.find(({ item }) => item.id === itemToMaintainVisible.item.id);
  if (!itemToMaintainVisibleUpdated) {
    return 0;
  }
  const { actualScroll } = params;
  const topOffset = actualScroll - itemToMaintainVisible.y;
  return itemToMaintainVisibleUpdated.y + topOffset;
}
export {
  getNewScrollValue
};
//# sourceMappingURL=getNewScrollValue.js.map
